import { render, staticRenderFns } from "./updateRecipientModal.vue?vue&type=template&id=1af15c19&scoped=true&"
import script from "./updateRecipientModal.vue?vue&type=script&lang=js&"
export * from "./updateRecipientModal.vue?vue&type=script&lang=js&"
import style0 from "./updateRecipientModal.vue?vue&type=style&index=0&id=1af15c19&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af15c19",
  null
  
)

export default component.exports